/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PersonalizedAdsToggleRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {PersonalizedAdsToggleResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const personalizedAdsToggle = (request:PersonalizedAdsToggleRequest, options?: CashRequestOptions) => post<PersonalizedAdsToggleRequest, PersonalizedAdsToggleResponse>("/cash-app/cash-plato/personalized-ads-toggle", request, {...options, rejectOnError: true })